import { GET_SAVE_DEFAULT_LOCATION, SET_IS_SAVE_DEFAULT_LOCATION } from "./DefaultLocationType"


const getSaveDefaultLocation = (payload: any) => {
    return {
      type: GET_SAVE_DEFAULT_LOCATION,
      payload
    }
}
const setISSaveDefaultLocation = (isSaveDefaultLocation: any) => {  
    return {
      type: SET_IS_SAVE_DEFAULT_LOCATION,
      isSaveDefaultLocation : isSaveDefaultLocation
    }
}

export {
    getSaveDefaultLocation,
    setISSaveDefaultLocation 
}
